
const Rohit = "/images/Internship/Rohit.webp";
const Roshan = "/images/Internship/Roshan.webp";
const Sruthi = "/images/Internship/Sruthi.webp";
const Kumkum = "/images/Internship/Kumkum.webp";
const Miyu = "/images/Internship/Miyu.webp";
const Giovanni = "/images/Internship/Giovanni.webp";
const Cole = "/images/Internship/Cole.webp";
const Parker = "/images/Internship/Parker.webp";
const Albane = "/images/Internship/Albane.webp";


const data = [
  {
    name: "Albane Goux-Thiercelin",
    post: "Architecture intern",
    image: Albane,
    about:
      "Being part of Akiya2.0 as an architecture intern was an enriching experience, both professionally and personally. Beyond discovering the renovation of traditional Japanese houses alongside local workers, it was also a deep immersion into rural life in Japan. The diversity of tasks allowed me to develop a wide range of tools, from photographic documentation to digital modeling techniques.",
    linkToBlog: "http://blog.com",
    linkToLinkedin:
      "https://www.linkedin.com/in/albane-goux-thiercelin-778a87351/",
  },
  {
    name: "Parker Witt",
    post: "Real Estate Analyst Intern",
    image: Parker,
    about:
      "As a Real Estate Analyst Intern, Akiya2.0 has given me a hands on place to grow and learn. Being put in charge of important projects and meaningful research all over Japan, I’ve been able to use my Finance and Japanese degree to their full extent in a place where it feels like they matter. Helping Akiya2.0 preserve Japanese culture and architecture is a fulfilling and enriching cause.",
    linkToBlog: "http://blog.com",
    linkToLinkedin:
      "https://www.linkedin.com/in/parkerwitt?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
  },
  {
    name: "Cole Martinez",
    post: "Marketing Intern",
    image: Cole,
    about:
      "As a marketing intern, AKIYA2.0s unique and flexible environment has allowed me to effectively learn and grow both my professional and marketing skills. Even with a background in Psychology, I felt that my skills and knowledge were welcomed and able to find a place in AKIYA2.0s endeavors.",
    linkToBlog: "http://blog.com",
    linkToLinkedin:
      "https://www.linkedin.com/in/cole-martinez-59913828b/",
  },
  {
    name: "Ibsen Giovanni BAZIE",
    post: "Software Engineer Intern",
    image: Giovanni,
    about:
      "As a software engineer intern from Burkina Faso based in Vietnam, I'm passionate about contributing to AKIYA2.0's user-centric solutions. Using cutting-edge technologies, I help build products that make a real difference in users' lives while growing my technical and creative skills.",
    linkToBlog: "http://blog.com",
    linkToLinkedin:
      "https://www.linkedin.com/in/bazieibsengiovanni/",
  },

  {
    name: "Shikama Miyu",
    post: "Marketing Intern",
    image: Miyu,
    about:
      "Working in AKIYA2.0's unique startup culture, I was exposed to so many new things and I was able to grow immensely in my role as a marketing intern. With the flexibility and community-based nature of the organization, I had such an important experience for my writing, marketing, and fundraising skills surrounded by wonderful people.",
    linkToBlog: "http://blog.com",
    linkToLinkedin:
      "https://www.linkedin.com/in/miyu-shikama-447588264/",
  },
  {
    name: "Kumkum Rathore",
    post: "Software Developer Intern",
    image: Kumkum,
    about:
      "The collaborative environment fostered creativity and innovation, and the mentorship I received was invaluable for honing my problem-solving abilities. Overall, it has been an amazing experience that enhanced my technical acumen and shaped me as a professional.",
    linkToBlog: "http://blog.com",
    linkToLinkedin:
      "https://www.linkedin.com/in/kumkum-rathore-b8388631b/",
  },
  {
    name: "Sruthi Gusidi",
    post: "Software Developer Intern",
    image: Sruthi,
    about:
      "Working as a software developer intern at AKIYA2.0 has been truly fulfilling. The atmosphere here cultivates development, promoting analytical as well as imaginative approaches. It's a hub of creativity and progress, where each day brings fresh chances to expand horizons and add value. ", // Akiya2.0 represents a harmonious mix of technical prowess and inventive spirit, providing an enriching setting to evolve and excel within.
    linkToBlog: "http://blog.com",
    linkToLinkedin: "https://www.linkedin.com/in/sruthigusidi/",
  },
  {
    name: "Roshan Kumar",
    post: "Software Developer Intern",
    image: Roshan,
    about:
      "In my role as a software developer intern at AKIYA2.0, I've undergone a remarkable journey of growth and learning. Immersed in the realm of innovation, my time here has been a catalyst for refining my technical abilities while fostering a culture of ingenuity and adaptability. ", // Akiya2.0 stands as a beacon at the crossroads of pioneering technology and intuitive design, and I'm exhilarated to play a part in its advancement, shaping the digital frontier.
    linkToBlog: "http://blog.com",
    linkToLinkedin: "https://www.linkedin.com/in/roshan-kumar-sinha-343062252/",
  },
  {
    name: "Rohit Naidu",
    post: "Software Developer Intern",
    image: Rohit,
    about:
      "As a software developer intern, my experience with AKIYA2.0 has been truly transformative. Working on this innovative product has not only honed my technical skills but also provided a dynamic environment where creativity and problem-solving converge. AKIYA2.0 represents the intersection of cutting-edge technology and user-centric design, and I am thrilled to contribute to its development, making a meaningful impact in the digital landscape.",
    linkToBlog: "http://blog.com",
    linkToLinkedin:
      "https://www.linkedin.com/in/rohit-naidu-siriporam-1291871b3/",
  },
  
];

export default data;
